import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { motion } from 'framer-motion';
import { selectUnitToken } from '@homeplay/app';
import { apiGetSuggestedBets } from '@homeplay/api';
import AssistantAvatar from '../AssistantAvatar';
import BetTicketsContainer from '../BetTicketsContainer';
import {
  useAssistantIntents,
  useAssistantState,
} from '../../hooks/useLottoAssistantContext';
import { LOTTO_CONSTANTS } from '../../constants';
import {
  containerVariants,
  letterVariants,
  fadeInVariants,
} from './animations';
import allLottoIcon from '../../../../../../shared/assets/images/lotto-assistant/all-lotto-white.svg';
import dreamIcon from '../../../../../../shared/assets/images/lotto-assistant/dream.svg';
import classes from './WelcomeScreen.module.scss';

const TITLE = 'Lottery Betting Assistant';

const WelcomeScreen = () => {
  const unitToken = useSelector(selectUnitToken);
  const { handleQuickPick, handleBrowseLotteries } = useAssistantIntents();
  const { setInputCommand } = useAssistantState();

  const [suggestedTickets, setSuggestedTickets] = useState([]);

  useEffect(() => {
    if (!unitToken) return undefined;
    let cancelled = false;
    apiGetSuggestedBets({ unitToken, stake: LOTTO_CONSTANTS.DEFAULT_STAKE })
      .then((data) => {
        if (cancelled) return;
        setSuggestedTickets(data?.bet_tickets ?? []);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [unitToken]);

  return (
    <div className={classes.Container}>
      <div className={classes.Content}>
        <div className={classes.TitleWrapper}>
          <AssistantAvatar size="large" />
          <p className={classes.Title}>
            <motion.span
              variants={containerVariants}
              initial="hidden"
              animate="visible"
            >
              {TITLE.split('').map((char, index) => (
                <motion.span
                  key={`${char}-${index}`}
                  variants={letterVariants}
                  style={{ whiteSpace: char === ' ' ? 'pre' : 'normal' }}
                >
                  {char}
                </motion.span>
              ))}
            </motion.span>
          </p>
        </div>

        <motion.div variants={fadeInVariants} initial="hidden" animate="visible">
          <p className={classes.Subtitle}>
            Ask me about hot numbers, check your bets,
            <br />
            or get personalized lottery recommendations
          </p>

          <div className={classes.ButtonsWrapper}>
            <button
              type="button"
              className={`${classes.ActionButton} ${classes.LotteriesButton}`}
              onClick={() => handleBrowseLotteries({ withSuggestedOptions: true })}
            >
              <img src={allLottoIcon} alt="" />
              All lotteries
            </button>
            <button
              type="button"
              className={`${classes.ActionButton} ${classes.QuickPickButton}`}
              onClick={() => handleQuickPick()}
            >
              <img src={allLottoIcon} alt="" />
              Quick pick
            </button>
            <button
              type="button"
              className={`${classes.ActionButton} ${classes.DreamButton}`}
              onClick={() => setInputCommand('/dream')}
            >
              <img src={dreamIcon} alt="" />
              My dream
            </button>
          </div>
        </motion.div>
      </div>

      {suggestedTickets.length > 0 && (
        <motion.div
          variants={fadeInVariants}
          initial="hidden"
          animate="visible"
          style={{ width: '100%' }}
        >
          <BetTicketsContainer
            tickets={suggestedTickets}
            messageId="welcome-screen-suggested-tickets"
            isDeleteAllowed={false}
            centered
          />
        </motion.div>
      )}
    </div>
  );
};

export default WelcomeScreen;
